import { PaperAirplaneIcon } from '@heroicons/react/24/outline';
import { Flex, Loader } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';

import { LBLinkButton } from '@/shared/ui-kit/components';

export const ChatMessageInput = ({
  sendMessage
}: {
  sendMessage: (message: string) => Promise<void>;
}) => {
  const [message, setMessage] = useState('');
  const [isSending, setIsSending] = useState(false); // <-- new loading state
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const onSubmit = async () => {
    if (!message.trim()) return;
    setIsSending(true); // start loading
    try {
      await sendMessage(message.trim());
      setMessage('');
    } finally {
      setIsSending(false); // stop loading
    }
  };

  const handleKeyDown = async (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      await onSubmit();
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.height = 'auto';
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
    }
  }, [message]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <Flex align='center' gap={10}>
        <div style={{ width: '100%' }}>
          <textarea
            ref={inputRef}
            placeholder='Написать сообщение'
            rows={1}
            value={message}
            style={{
              width: '100%',
              height: '40px',
              borderRadius: '20px',
              resize: 'none',
              overflow: 'hidden',
              border: '1px solid #ccc',
              fontSize: '14px',
              padding: '0 12px',
              boxSizing: 'border-box',
              lineHeight: '40px',
              verticalAlign: 'middle'
            }}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <LBLinkButton
          disabled={isSending} // disable when loading or empty
          type='submit'
          style={{
            background: '#f74360',
            color: 'white',
            borderRadius: '24px',
            padding: '7px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // cursor: 'pointer',
            cursor: isSending ? 'not-allowed' : 'pointer'
          }}
        >
          {isSending ? (
            <Loader color='white' size='sm' variant='dots' />
          ) : (
            <PaperAirplaneIcon width={24} />
          )}
        </LBLinkButton>
      </Flex>
    </form>
  );
};
